import { connect } from 'react-redux';
import ForgetPassword from '../components/ForgetPassword/ForgetPassword';
import * as actions from '../redux/actions/ForgetPassword';

const mapStateToProps = (state) => {
  return {
    error: state.forgetPassword.error,
    requested: state.forgetPassword.requested
  };
};

const mapDispatchToProps = dispatch => ({
  requestPassword(requestInfo) {
    dispatch(actions.requestPassword(requestInfo));
  },

  resetForgetPassword() {
    dispatch(actions.resetForgetPassword());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);



// WEBPACK FOOTER //
// ./src/containers/ForgetPassword.js